import Routes from '../routes/routes'
import { buildPatchApi } from './helpers'

export default buildPatchApi({
    route: Routes.apiUpdateNumberPlatesWhitelistEnabled,
    buildResult: () => true,
    mapPayload: ({ enabled }) => ({corporate_plates_whitelist_enabled: enabled}),
    mapParams: ({ id }) => ({ idWallet: id }),
})
